var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-mobile",
    transform: "translate(-714 4339)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_14",
    "data-name": "Ligne 14",
    x1: 15,
    transform: "translate(715.5 -4337.5)",
    fill: "none",
    stroke: "#004993",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_15",
    "data-name": "Ligne 15",
    x1: 15,
    transform: "translate(715.5 -4330.5)",
    fill: "none",
    stroke: "#004993",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_16",
    "data-name": "Ligne 16",
    x1: 15,
    transform: "translate(715.5 -4323.5)",
    fill: "none",
    stroke: "#004993",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMobile);
export default __webpack_public_path__ + "static/media/menu_mobile.3c246c57a90b3dd1bec60667e394e327.svg";
export { ForwardRef as ReactComponent };